module.exports = __webpack_public_path__ + "static/media/csv_icn.a4f018b9.svg";